import React from "react";
import PropTypes from "prop-types";
import { Empty } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faLock } from "@fortawesome/free-solid-svg-icons";
import { UI_COLORS } from "../../config";
import { useTranslation } from "../../i18n";

export default function NoKeysPlaceholder({ noPermission = false }) {
  const { t } = useTranslation();
  
  const icon = noPermission ? faLock : faFile;
  const title = noPermission 
    ? t("keysList.noPermission") 
    : t("keysList.noKeys");
  const description = noPermission 
    ? t("keysList.noPermissionDescription") 
    : t("keysList.noKeysDescription");

  return (
    <div className="h-full flex flex-col border border-gray-200 rounded-md mt-4">
      <div className="flex-grow flex items-center justify-center bg-gray-50 p-8">
        <div className="text-center">
          <Empty
            image={
              <FontAwesomeIcon
                icon={icon}
                style={{ 
                  fontSize: 48, 
                  color: "rgb(156 163 175)" 
                }}
              />
            }
            description={
              <div>
                <h3 className="mt-2 text-sm font-medium text-gray-900" style={{ color: UI_COLORS.text || undefined }}>
                  {title}
                </h3>
                <p className="mt-1 text-sm text-gray-500">{description}</p>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
}

NoKeysPlaceholder.propTypes = {
noPermission: PropTypes.bool,
};